import { CommonState } from '~/store/commonStore'

export const getBaseState = (state: CommonState) => state.pages.searchResults
